document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".mySwiper", {
      slidesPerView: 4.7,
      spaceBetween: 4,
      loop: false,
      speed: 600,
      grabCursor: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        1024: {
          slidesPerView: 4.7
        },
        768: {
          slidesPerView: 3
        },
        480: {
          slidesPerView: 2
        },
        0: {
          slidesPerView: 1.2
        }
      }
    });
  });